var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.click()}}},[_c('video',{staticStyle:{"width":"100%","max-height":"300px"},attrs:{"controls":"","src":_vm.getMediaItem()}})])}
var staticRenderFns = []

export { render, staticRenderFns }